import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import { api } from "../api";

function StatCard({ label, value, color }) {
  return (
    <div className="card" style={{ textAlign: "center", padding: "28px 20px" }}>
      <div style={{ fontSize: 42, fontWeight: 700, color: color || "var(--navy)" }}>{value}</div>
      <div style={{ fontSize: 13, color: "var(--gray)", marginTop: 6, fontWeight: 600, textTransform: "uppercase", letterSpacing: ".04em" }}>{label}</div>
    </div>
  );
}

export default function DashboardAdmin() {
  const [stats, setStats] = useState(null);
  const [recientes, setRecientes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.getStats(), api.getRecibos({ estado: "pendiente" })])
      .then(([s, r]) => { setStats(s); setRecientes(r.slice(0, 8)); })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Layout><div style={{ padding: 60, textAlign: "center" }}><div className="spinner" /></div></Layout>;

  const pct = stats?.total > 0 ? Math.round((stats.firmados / stats.total) * 100) : 0;

  return (
    <Layout>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 32, flexWrap: "wrap", gap: 16 }}>
        <div>
          <h1 style={{ fontSize: 24, fontWeight: 700, color: "var(--navy)" }}>Resumen</h1>
          <p style={{ color: "var(--gray)", marginTop: 4 }}>Estado general de los recibos</p>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <Link to="/admin/recibos" className="btn btn-primary">Gestionar recibos</Link>
          <a href={api.exportUrl()} className="btn" download>Exportar CSV</a>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 16, marginBottom: 32 }}>
        <StatCard label="Total publicados" value={stats?.total || 0} />
        <StatCard label="Firmados" value={stats?.firmados || 0} color="var(--success)" />
        <StatCard label="Pendientes" value={stats?.pendientes || 0} color="var(--warning)" />
        <StatCard label="Empleados activos" value={stats?.total_empleados || 0} />
      </div>

      {stats?.total > 0 && (
        <div className="card" style={{ marginBottom: 32 }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10, fontSize: 14, fontWeight: 600 }}>
            <span>Progreso de firmas</span>
            <span style={{ color: "var(--navy)" }}>{pct}%</span>
          </div>
          <div style={{ background: "var(--border)", borderRadius: 99, height: 10, overflow: "hidden" }}>
            <div style={{
              width: `${pct}%`, height: "100%",
              background: "var(--navy)", borderRadius: 99,
              transition: "width .5s",
            }} />
          </div>
          <div style={{ fontSize: 12, color: "var(--gray)", marginTop: 8 }}>
            {stats.firmados} de {stats.total} recibos firmados
          </div>
        </div>
      )}

      {recientes.length > 0 && (
        <div>
          <h2 style={{ fontSize: 16, fontWeight: 700, marginBottom: 16, color: "var(--navy)" }}>
            Pendientes de firma
          </h2>
          <div className="card" style={{ padding: 0, overflow: "hidden" }}>
            <table>
              <thead>
                <tr>
                  <th>Empleado</th>
                  <th>Concepto</th>
                  <th>Período</th>
                  <th>Publicado</th>
                </tr>
              </thead>
              <tbody>
                {recientes.map(r => (
                  <tr key={r.id}>
                    <td style={{ fontWeight: 500 }}>{r.apellido}, {r.nombre}</td>
                    <td>{r.concepto}</td>
                    <td>{r.periodo}</td>
                    <td style={{ fontSize: 13, color: "var(--gray)" }}>
                      {r.publicado_at ? new Date(r.publicado_at).toLocaleDateString("es-AR") : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </Layout>
  );
}
